import { COLUMN_NAME, COLUMN_SLOT } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const ReasonCodeColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "arcDesc",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Slot",
        accessor: "slot",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "slot",
        columnId: COLUMN_SLOT,
    },
];

export default ReasonCodeColumns;
